<template>
  <div>
    <Button type="warning" size="small" @click="seeKz">查看</Button>
    <Button type="warning" size="small" @click="pushMsg">推送消息</Button>
  </div>
</template>

<script>
  export default {
    name: "repeat-operation",
    props: {
      operation: {
        type: Object,
      }
    },
    methods: {
      //查看客资
      seeKz() {
        this.$store.commit('setRepeatKz',false)
        this.$bus.emit('editCustomerModal', {status: true, id: this.operation.kzid})
      },

      //推送消息
      pushMsg(){
        this.$http.get("add/push_repeat_msg",{
          params:{
            kzId:this.operation.kzid
          }
        }).then(data=>{
          if(data.code === 100000){
            this.$Message.success(data.msg)
          }else{
            this.$Message.error(data.msg)
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/repeat-kz/repeat-operation.vue